$(document).ready(function() {

  // Product Page -  Tabs
  $('.product-nav-tabs li a').click(function(e){
      e.preventDefault();
      var tab_data = $(this).attr('href');
      $('.product-nav-tabs li a').removeClass('active');
      $('.product-tab-content').removeClass('active');
      $(this).addClass('active');
      $('.product-tab-content'+tab_data).addClass('active');
  });

  function close_accordion_section_2() {
      $('.product-tab-title').removeClass('active');
      $('.product-tab-content').slideUp(300).removeClass('active');
  }
  $('.product-tab-title').click(function(e) {
    var $nextDiv = $(this).next('.product-tab-content');

    if($(this).is('.active')) {
        close_accordion_section_2();
    }else {
        close_accordion_section_2();
        $(this).addClass('active');
        $nextDiv.slideDown(300).addClass('active');
    }
    e.preventDefault();
  });

  $('.filter-group .title').click(function(e) {
      var $nextDiv = $(this).next('.filter-nav');

      $nextDiv.slideToggle(400);
      e.preventDefault();
  });



  // Contact Us page - FAQ section
  if($('#faq').length && $('#faq-content').length) {
    $('#faq-content').prependTo('#faq');
  }


  // FAQ section
  if($('#accordion').length) {  
    var parentDivs = $('#accordion .accordion-inner, #accordion .accordion-body'),
        childDivs = $('#accordion .accordion-heading').siblings('.accordion-body');

    $('#accordion h3').click(function () {
    $(this).toggleClass('active');
    $("#accordion h3").not(this).removeClass('active'); 
    $('#accordion .accordion-heading').removeClass('active');
        parentDivs.slideUp();
    
        if ($(this).next('.accordion-inner').is(':hidden')) {
            $(this).next('.accordion-inner').slideDown();     
        } else {
            $(this).next('.accordion-inner').slideUp();
        }
    });

    $('#accordion .accordion-heading').click(function () {
    $(this).toggleClass('active');        
    $(this).siblings('.accordion-heading').removeClass('active'); 
        childDivs.slideUp();    
        if ($(this).next().is(':hidden')) {
            $(this).next().slideDown();
      $(this).next().addClass('active');
        } else {
            $(this).next().slideUp();
      $(this).next().removeClass('active');
        }
    });
  } 


  // JOBS page
  $('.jobs-nav li a').click(function(e) {
    var target = $(this).attr('href');
    console.log(target);
    $('.jobs-nav li a').removeClass('active');
    $(this).addClass('active');
    $('.featured-jobs').removeClass('active').hide();
    $('.featured-jobs'+target).fadeIn(300);
    e.preventDefault();
  });


  // Store locator map overlay  toggle button      
  $('.gmap-toggle-btn').on('click',function(){
    var md = $(this).next('.gmap-overlay');
    if( md.hasClass('hide') ){
      $(this).text('enable map controls');
      md.removeClass('hide');
    }else{
      $(this).text('disable map controls');
      md.addClass('hide');
    }
    return false;
  });


  // Home featured products 
  if ($('.home-featured-products-grid').length) {    
    $('.home-featured-products-grid').slick({
      dots: false,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 592,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  // Product slider
  if($('.main-slider-for').length) {
    $('.main-slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.thumbs-slider-nav',
       responsive: [
        {
          breakpoint: 590,
          settings: {
            dots:true
          }
        }
      ]
    });

    $('.thumbs-slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: '.main-slider-for',
      dots: false,
      focusOnSelect: true
    });
    



    $('.product-single__variants').change(function() {
      var xIndex = 0;
      var variantImg = $(this).find('option:selected').data('img');
      //console.log(variantImg);
      $('.product-single__photo-wrapper').not('.slick-cloned').each(function() {
        var xImg = $(this).find('img').attr('src');
        if (xImg == variantImg) {
          xIndex = $(this).closest('.product-single__photo-wrapper').attr('data-slick-index');
        }
      });

      if ($('.product-main-slider').size() > 0) {
        var slider = $('.product-main-slider');
        slider[0].slick.slickGoTo(xIndex);
      }
      
 
    });
    $('#AddToCartForm .single-option-selector__radio').change(function() {
      $('.product-single__variants').trigger('change')
    });

  }
  if ($('.product-main-slider').size() > 0) {
    var initPhotoIndex = $('.init-photo').attr('data-slick-index');
    var slider = $('.product-main-slider');
      slider[0].slick.slickGoTo(initPhotoIndex);
  }  

  

  
  //Recently Viewed slider in Product Page
  if($('#shopify-section-product-template').length) {
    var init = function() {  
       Shopify.Products.showRecentlyViewed({ 
        howManyToShow:12,
        onComplete: function() {
          loadRecentlySlider();
        }
       });
    };
    $(init);
    Shopify.Products.recordRecentlyViewed();

    function loadRecentlySlider() {
      if($('#recently-viewed-slider').length) {
        if($(window).width()>768) {  
          $('#recently-viewed-slider').slick({
              dots: true,
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            });
        }
        else if($(window).width() > 767 && $(window).width() < 769 ) {  
          $('#recently-viewed-slider').slick({
              dots: true,
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            });
        }
        else {
          $('#recently-viewed-slider').slick({
              dots: false,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            });
        }
      }
    }
  }

  // mobile nav button
  $('.mobile-nav-trigger').click(function(e) {
    $('body').toggleClass('menuOpen');
    var isSticky = $('.site-header').hasClass('sticky');
    if (isSticky == true) {
      $('.mobile-nav-wrapper').css('top', $('.site-header').outerHeight()); 
    } else {
      $('.mobile-nav-wrapper').css('top', $('[data-section-type="header-section"]').height()); 
    }
    
  });
  $('.menuOverlay').click(function(e) {
    $('body').removeClass('menuOpen');
  });

  // store selector on mobile
  /*
  $('.store-selector-link').click(function(e) {
    if ($('.mobile-nav-wrapper').is(':visible')) {
      $('.mobile-nav-wrapper').slideUp(300);
    }
    $('.mobile-store-selector-wrapper').slideToggle(300);
  });
  */

});